// @flow
import { depositedSlipDashboardActions } from './depositSlipDashboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashboardData: [],
  totalElements: 0,
  pageNumber: 0,
  pageSize: 20,
  depositSlipDetail: {},
  error: null,
  submitBankSlipModalLoader: false
};

const depositSlipDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case depositedSlipDashboardActions.SET_DASHBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case depositedSlipDashboardActions.SET_DEPOSIT_SLIP_DETAILS_FOR_MODAL: {
      return Object.assign({}, state, action.payload);
    }
    case depositedSlipDashboardActions.UPDATE_PAGE_NUMBER: {
      return Object.assign({}, state, { pageNumber: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default depositSlipDashboardReducer;
